import { css } from '@emotion/react'
import { CSSProperties, memo } from 'react'
import MissMFCBadge from './MissMFC'
import NewBadge from './New'

interface NewAndMissMFCBadgesProps {
    enablePinToTopSymbols?: boolean
    isPinnedToTopMissMFC?: boolean
    missMFCCompact?: boolean
    missMFCRank?: number
    showMissMFC?: boolean
    showNew?: boolean
    styleOverrides?: CSSProperties
}

const missMfcBadgeStyles = css({
    borderBottomLeftRadius: 4,
    borderTopRightRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0px 3px',
    background: '#fff',
    display: 'flex',
    opacity: 0.65,
    color: '#333',
})

const detailedMissMfcBadgeStyles = css({
    borderBottomRightRadius: 2,
    borderTopRightRadius: 2,
    borderBottomLeftRadius: 2,
    borderTopLeftRadius: 2,
    width: '100%',
    marginTop: 3,
})

const NewAndMissMFCBadges = memo((props: NewAndMissMFCBadgesProps) => {
    const {
        enablePinToTopSymbols,
        isPinnedToTopMissMFC,
        styleOverrides = {},
        missMFCCompact,
        missMFCRank,
        showMissMFC,
        showNew,
    } = props

    if (enablePinToTopSymbols && !isPinnedToTopMissMFC) {
        return null
    }

    return (
        <div
            css={[missMfcBadgeStyles, detailedMissMfcBadgeStyles]}
            style={styleOverrides}
        >
            {showNew && (
                <NewBadge
                    styleOverrides={{
                        marginRight: showMissMFC ? 4 : 0,
                        padding: 0,
                    }}
                />
            )}
            {showMissMFC && (
                <MissMFCBadge
                    missMFCRank={missMFCRank}
                    compact={missMFCCompact}
                />
            )}
        </div>
    )
})

export default NewAndMissMFCBadges
export { NewAndMissMFCBadges }
